import { ReducerUtil } from 'doctivity-shared/utils';
import { success } from 'redux-saga-requests';
import { StoreUtil } from 'doctivity-shared/utils';
import {
  API_TABLE_USERS,
  API_LIST_USERS,
  API_UPSERT_USER,
  API_LOAD_USER,
} from 'store/actions/usersActions';

export const users = (state = {}, action = null) => {
  let result = ReducerUtil.simpleReduce(
    state,
    action,
    API_TABLE_USERS,
    API_LIST_USERS,
    API_UPSERT_USER,
  );

  if (result.actionConsumed) {
    /* -----------------------------------------------------------------
     * If the action was UPSERT_USER_SUCCESS, copy the record that is now
     * in COMMON_EDIT_ITEM into COMMON_ITEM as well.
     * ----------------------------------------------------------------- */
    if (action.type === success(API_UPSERT_USER)) {
      const saved = action.response?.data || action.data;
      
      // Don't preserve old clients - the save data has the new client_ids
      // We need to fetch the full user data to get the clients array populated
      return {
        ...result.state,
        [StoreUtil.COMMON_ITEM]: {
          ...result.state[StoreUtil.COMMON_ITEM],
          [saved.id]: {
            data: saved,
            loading: false,
            saving: false,
            saved: true,
          },
        },
      };
    }

    if (action.type === API_LIST_USERS && action.clientId && result.state) {
      result.state.listClientId = action.clientId;
    }
    
    return result.state;
  }
  
  result = ReducerUtil.reduceSingleGet(state, action, API_LOAD_USER);
  if (result.actionConsumed) {
    return result.state;
  }
  
  return state;
};